import type { FaireProductEntity } from "../../entity_types/product";

export const p_6zpfhgt9eb: FaireProductEntity = {
  token: "p_6zpfhgt9eb",
  type: "product",
  name: "Keep It Up Oversized Cardigan - Mustard",
  brandToken: "b_41hrqq6ws3",
  brandName: "Three Bird Nest",
  imageUrl:
    "https://cdn.faire.com/fastly/917152d11af7b16d1c74aac57967e65c8943910fbc6985f3d81c2bf4b4a843ce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/900f23f94c99f52ba4a063ffdfa2d1f5dabe6c40915038069bfe4327de7d91bc.jpeg",
    "https://cdn.faire.com/fastly/0cee1e24aa6a65601288a652b31ce4acc40ef70d57619af8d8df43a24538f8dd.jpeg",
    "https://cdn.faire.com/fastly/fc3866c3b53bc92776a0033a070b79bc1c4687672895a0ee9407af69bd5e9505.jpeg",
    "https://cdn.faire.com/fastly/45b9e09e293974141bea322722ebbff83d692ae1436ae69bbf0718703415f7f5.jpeg",
    "https://cdn.faire.com/fastly/7fa2b0cab3338dd6b9bd064813a85a368cb1caee5bb3ddf1766293cdceb9953b.jpeg",
    "https://cdn.faire.com/fastly/ae636f626d3478508cb52c274689311bca3e85fde1532499163fe7b97ee42747.jpeg",
  ],
  priceDollars: 51.27,
  description:
    'The Keep It Up Oversized Cardigan is perfect for chilly days and will become a staple in your boho wardrobe because it features:\n\n * Warm and cozy, fuzzy, thick knit fabric \n * Oversized cardigan style \n * Bohemian-inspired geometric design throughout \n * Open front \n * Dropped shoulder with oversized short sleeves \n * Large patch pockets along the front \nCozy cute boho outfit pair with: High Neck Racerback Brami, Jodi Jumpsuit, Messy Bun Knitted Beanie Hat\n\nModel is 5\'8" and wearing a size OS.\n\nApproximate measurements are as follows:\n\n * OS: OS: Bust: 58", Length 29", Sleeve Length: 21" \n\n * 50% Acrylic, 50% Polyester \n * Hand wash cold, Lay flat to dry \n * Import',
  tags: [],
  msrpDollars: 102.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:44.760Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
